module.exports = __webpack_public_path__ + "static/media/ship-icon.30c66c17.png";